<template>
  <div class="button-expand" :class="{ 'is-active' : isActive, 'has-selected' : hasSelected }">
    <div class="header" @click="handleToggle">
      <div>
        <div class="h4">{{ province.Name }}</div>
        <small>{{ provinceTowns.length }} Localities <template v-if="hasSelected">({{ provinceTownsSelected.length }} selected)</template></small>
      </div>
      <img class="icon icon-minus" src="@/assets/icons/minus.svg" alt="">
      <img class="icon icon-plus" src="@/assets/icons/plus.svg" alt="">
    </div>
    
    <div class="body">
      <hr>
      <label class="button button--sm button--toggle button--toggle-solid" :class="{ 'is-active' : filtersTowns.includes(town.Id) }"
        v-for="town in provinceTowns"
        :key="town.Id"
      >
        <input 
          type="checkbox"
          :value="town.Id"
          v-model="filtersTowns"
        >
        {{ town.Name }} 
      </label>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .button-expand {
    display: inline-block;
    width: 335px;
    margin: 0.5em;
    border-radius: 4px;
    border: 2px solid transparent;
    background-color: rgb(var(--white));
    box-shadow: 0 0 10px 5px rgba(0,0,0,0.1);

    color: rgb(var(--gray-10));
    font-size: var(--p);
    font-weight: var(--weight-bold);

    cursor: pointer;   
  
    hr {
      margin: 0 0.5em 1em;
      border: 0;
      border-bottom: 1px solid rgb(var(--gray-0));
    }

    .icon {
      width: 2rem;
      height: 2rem;
    }

    .icon-minus {
      display: none;
    }

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      padding: 1.2em;

      .h4 {
        margin-bottom: 0;
      }
    }

    .body {
      overflow: hidden;
      height: 0;
    }

    &.has-selected {
      border-color: rgb(var(--red-0));
    }

    &.is-active {
      position: relative;
      border-color: rgb(var(--red-0));

      .icon-plus {
        display: none;
      }

      .icon-minus {
        display: initial;
      }

      .header {
        position: relative;
        z-index: 2;
        height: auto;
        background-color: rgb(var(--white));
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;

        color: rgb(var(--red-0));
      }

      .body {
        height: auto;
        margin: 0 0.7em;
        padding-bottom: 0.7em;
        border: 2px solid transparent;
        background-color: rgb(var(--white));

        @include min-sm {
          position: absolute;
          z-index: 1;
          width: calc(100% + 4px); // 4px accounts for border
          padding: 0 0.7em 0.7em;
          margin: 0 -2px;
          border-color: rgb(var(--red-0));
          border-top: 0;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          box-shadow: 0 0 10px 5px rgba(0,0,0,0.1);
        }
      }
    }
  }
</style>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'ButtonExpand',

    props: {
      province: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      isActive: false
    }),

    computed: {
      ...mapGetters([
        'getProvinceTownsById'
      ]),

      provinceTowns () {
        return this.getProvinceTownsById(this.province.Id)
      },

      provinceTownsSelected () {
        return this.provinceTowns.filter(el => this.filtersTowns.find(id => el.Id === id));
      },

      filtersTowns: {
        get () {
          return this.$store.state.filters.towns;
        },

        set (value) {
          this.$store.commit('updateTownsFilter', value)
        }
      },

      hasSelected () {
        return this.provinceTownsSelected.length > 0;
      }
    },

    methods: {
      handleToggle (e) {
        return this.isActive ? this.hide(e) : this.show(e);
      },

      show (e) {
        this.isActive = true;
        document.addEventListener('click', this.docClick, false)
      },

      hide (e) {
        this.isActive = false;
        document.removeEventListener('click', this.docClick, false)
      },

      docClick (e) {
        if (this.$el.contains(e.target)) return;

        this.hide(e);
      },
    }
  };
</script>